import { Drawer } from 'antd';
import { DrawerStyle } from './style';
import moment from 'moment';

const Details = ({ setShowDrawer, showDrawer, tableObj, setTableObj, gmrfidCode }) => {
  const onClose = () => {
    setShowDrawer(false);
    setTableObj({});
  };

  const manageTypeFn = (key) => {
    let str = '';
    switch (key) {
      case 'COMPANY_MANAGE':
        str = '物业公司管理';
        break;
      case 'VILLAGE_MANAGE':
        str = '社区管理';
        break;
      case 'OWNER_MANAGE':
        str = '业主自治';
        break;
      default:
        break;
    }
    return str;
  };

  return (
    <Drawer
      title=""
      placement="right"
      size="large"
      onClose={onClose}
      visible={showDrawer}
      className="drawerModal"
      destroyOnClose
      width={720}
    >
      <DrawerStyle>
        <div className="drawer-top">
          <h1>
            项目详情
            <div className="clear" onClick={onClose}>
              x
            </div>
          </h1>
        </div>
        <div className="drawer-content">
          <ul className="list">
            <li>
              <label>项目名称：</label> <div>{tableObj?.name || ''}</div>
            </li>
            <li>
              <label>行政区划：</label>
              <div>
                {`${tableObj?.province || ''}/${tableObj?.city || ''}/${tableObj?.area || ''}/${
                  tableObj?.street || ''
                }/${tableObj?.community || ''}`}
              </div>
            </li>
            <li>
              <label>创建人：</label> <div>{tableObj?.creatorName || ''}</div>
            </li>
            <li>
              <label>创建时间：</label>
              <div>{tableObj?.createDate && moment(tableObj?.createDate).format('YYYY-MM-DD HH:mm:ss')}</div>
            </li>
            <li>
              <label>认证状态：</label>
              <div>
                {tableObj?.verifyState === 'NOT_VERIFIED' && '未认证'}
                {tableObj?.verifyState === 'VERIFIED' && '已认证'}
              </div>
            </li>
            <li>
              <label>管理现状：</label> <div>{manageTypeFn(tableObj?.manageType)}</div>
            </li>
            <li>
              <label>是否成立业委会：</label>
              <div>
                {tableObj?.isCommittee === true && '是'}
                {tableObj?.isCommittee === false && '否'}
              </div>
            </li>
            <li>
              <label>物业公司服务模式：</label>
              <div>{tableObj?.serviceModel ? (tableObj?.serviceModel === 'CJZ' ? '筹金制' : '包干制') : ''}</div>
            </li>
            <li>
              <label>人员数量：</label>
              <div>
                {`共计${tableObj?.ownerCount + tableObj?.renterCount + tableObj.relativesCount}人`}
                {`(业主${tableObj?.ownerCount}人，租客${tableObj.renterCount}人，亲属${tableObj.relativesCount}人)`}
              </div>
            </li>
            <li>
              <label>房屋数量：</label>
              <div>{`共计${tableObj?.houseCount}个`}</div>
            </li>
            <li>
              <label>功能套餐：</label>
              <div>{tableObj?.comboObj?.name}</div>
            </li>
          </ul>
        </div>
      </DrawerStyle>
    </Drawer>
  );
};
export default Details;
